<template>
    <div class="lms__superadmin_archived_list">
        <div class="lms__superadmin_archived_list_header">
            <view-actions
                :title="'Archived'"
                :cancel-button-active="false"
                :submit-button-active="false"
            />
        </div>
        <div class="lms__superadmin_archived_list_main">
            <component-list
                :component-table="LmsSuperadminArchivedListTable"
                :component-table-name="'archived'"
                :filter-search-queryable="true"
                :filter-select-active="true"
                :filter-select-items="filtersSelect"
                :get-pagination-getter="'getLmsSuperadminDeletedObjectsPagination'"
                :get-items-getter="'getLmsSuperadminDeletedObjectsData'"
                :get-items-dispatch="'lmsSuperadminDeletedObjectsGet'"
                :get-items-dispatch-trigger-name="'trigger-get-archived'"
                :item-name="['archived object', 'archived objects']"
                :table-preferences-active="true"
            />
        </div>
    </div>
</template>

<script>
import LmsSuperadminArchivedListTable from '@/components/lms/superadmin/archived/list/LmsSuperadminArchivedListTable'
import ViewActions from '@/components/default/shared/ViewActions'
import ComponentList from '@/components/default/shared/ComponentList'

export default {
  name: 'lms-superadmin-archived-list',
  components: { ComponentList, ViewActions },
  data () {
    return {
      LmsSuperadminArchivedListTable
    }
  },
  computed: {
    filtersSelect () {
      return [
        {
          key: 'type',
          label: 'Type',
          type: 'checkbox',
          values: [
            {
              label: 'Customer',
              value: 'customer'
            },
            {
              label: 'Workspace',
              value: 'workspace'
            }
          ]
        }
      ]
    }
  },
  methods: {
    createArchived () {
      this.$router.push({ name: 'lms-superadmin-archived-add' })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/archived/_lmssuperadminarchivedlist.scss";
</style>
